"use client";

import {
  ProjectCard,
  ProjectCardSkeleton,
  type ProjectCardData,
} from "../card";

interface ProjectsGridProps {
  projects: ProjectCardData[];
  loading: boolean;
}

export function ProjectsGrid({ projects, loading }: ProjectsGridProps) {
  if (loading) {
    return (
      <>
        <div
          aria-hidden="true"
          className="grid grid-cols-1 gap-4 p-page sm:grid-cols-[repeat(auto-fill,minmax(260px,1fr))] sm:gap-6 shimmer shimmer-bg text-foreground"
        >
          {Array.from({ length: 12 }).map((_, i) => (
            <ProjectCardSkeleton key={i} index={i} />
          ))}
        </div>
        <div role="status" aria-live="polite" className="sr-only">
          Loading projects…
        </div>
      </>
    );
  }

  return (
    <ul
      role="list"
      aria-label="Projects"
      aria-busy="false"
      className="list-none grid grid-cols-1 gap-4 p-page sm:grid-cols-[repeat(auto-fill,minmax(260px,1fr))] sm:gap-6 animate-[fade-in_0.08s_ease-out]"
    >
      {projects.map((project, i) => (
        <li key={project.id} className="list-none">
          <ProjectCard project={project} priority={i < 4} />
        </li>
      ))}
    </ul>
  );
}
